<template>
  <div class="split-section" ref="splitSection">
    <!-- 左侧部分 -->
    <div class="chimney-split-left" ref="leftSection">
      <!-- 左侧文字区域 -->
      <div class="chimney-left-text" ref="leftText">
        <span class="left-text-top">{{ leftTopText }}</span>
        <span class="left-text-bottom">{{ leftBottomText }}</span>
      </div>

      <!-- 左侧图片 -->
      <div class="chimney-left-image-container" ref="leftImage">
        <img
            :src="leftImageSrc"
            :alt="leftImageAlt"
            class="content-image"
        >
      </div>
    </div>

    <!-- 右侧部分 -->
    <div class="split-right" ref="rightSection">
      <!-- 右侧图片 -->
      <div class="right-image-container" ref="rightImage">
        <img
            :src="rightImageSrc"
            :alt="rightImageAlt"
            class="content-image"
        >
      </div>

      <!-- 右侧文字区域 -->
      <div class="chimney-right-text" ref="rightText">
        <div class="right-text-top">
          <span class="text-primary">{{ rightFirstPart }}</span>
          <span class="text-secondary">{{ rightSecondPart }}</span>
        </div>
        <div class="right-text-bottom">
          <p>{{ rightText1 }}</p>
          <p>{{ rightText2 }}</p>
          <p>{{ rightText3 }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import image1 from "../../static/series/evo/cutbed.png"
import image2 from "../../static/series/evo/图片6.png"

export default {
  name: 'SplitSection',
  props: {
    // 左侧图片
    leftImageSrc: {
      type: String,
      default: image1
    },
    leftImageAlt: {
      type: String,
      default: '左侧图片展示'
    },
    // 右侧图片
    rightImageSrc: {
      type: String,
      default: image2
    },
    rightImageAlt: {
      type: String,
      default: '右侧图片展示'
    },

  },
  data() {
    return {
      // 左侧文字
      leftTopText: this.$i18n.t('series.cuttingRoom'),
      leftBottomText: this.$i18n.t('series.chimney'),
      // 右侧文字 - 第一行两部分
      rightFirstPart: this.$i18n.t('series.concealed'),
      rightSecondPart: this.$i18n.t('series.misChimney'),
      // 右侧下面三行文字
      rightText1: this.$i18n.t('series.chimney_right_text1'),
      rightText2: this.$i18n.t('series.chimney_right_text2'),
      rightText3: this.$i18n.t('series.chimney_right_text3'),
      imagesLoaded: {
        left: false,
        right: false
      },
      animationInited: false,
      isMobile: false
    };
  },
  methods: {
    checkDevice() {
      const isMobile = window.innerWidth < 768;
      this.isMobile = isMobile;
    },
    initAnimation() {
      if (this.animationInited) return;

      this.$gsap.set(['.chimney-right-text', '.right-image-container'], {
        opacity: 0
      })

      const masterTimeline = this.$gsap.timeline({
        scrollTrigger: {
          trigger: '.chimney-left-text',
          start: 'top 150%',
          end: 'bottom 20%',
          markers: false,
          toggleActions: 'play none none reverse',
          once: true,
          scrub: false
        }
      });

      //
      masterTimeline.from('.chimney-left-text', {
        y: 150,
        opacity: 0,
        duration: 1,
        ease: 'power2.in'
      }, 0.5)
      masterTimeline.from('.chimney-left-image-container', {
        x: 200,
        opacity: 0,
        duration: 1,
        ease: 'power2.in'
      }, 0.5)

      masterTimeline.to('.chimney-left-image-container', {
        y: -350,
        duration: 1,
        ease: 'power2.in'
      }, 2);

      masterTimeline.to(['.left-text-top', '.left-text-bottom'], {
        color: "#808080",
      }, 2)

      masterTimeline.to('.chimney-left-text', {
        y: -50,
        duration: 1,
        color: "#808080",
        ease: 'power2.in'
      }, 2)

      masterTimeline.to('.chimney-right-text', {
        opacity: 1,
        y: -400,
        x: 15,
        duration: 1,
        color: "#808080",
        ease: 'power2.in'
      }, 2)

      masterTimeline.to('.right-image-container', {
        opacity: 1,
        y: -400,
        duration: 1,
        color: "#808080",
        ease: 'power2.in'
      }, 2)

      this.animationInited = true;
    }
  },
  mounted() {
    this.checkDevice();
    window.addEventListener('resize', this.checkDevice);

    this.$nextTick(() => {
      this.initAnimation();
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkDevice);
  }
};
</script>

<style scoped>
.split-section {
  display: flex;
  width: 100%;
  margin: 0 auto;
  padding: 10rem 5rem;
  box-sizing: border-box;
  gap: 3rem;
  align-items: flex-start;
  margin-top: 500px;
  flex-direction: column;
  height: 150vh;
}

.chimney-split-left, .split-right {
  flex: 1;
  min-width: 300px;
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
}

.chimney-split-left {
  display: flex;
  flex-direction: row;
  margin-left: 100px;
  justify-content: space-around;
}

.split-right {
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-around;
  margin-left: 100px;

}

/* 左侧文字样式 - 强制左对齐 */
.chimney-left-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start; /* 保持左对齐 */
  margin-top: 200px;
}

.left-text-top {
  font-size: var(--font-size-lg2);
  color: #222;
  margin: 0;
  line-height: 1.2;
  max-width: 400px;
  text-align: left; /* 强制左对齐 */
}

.left-text-bottom {
  font-size: var(--font-size-lg2);
  font-weight: 700;
  color: #222;
  margin: 0;
  line-height: 1.2;
  max-width: 400px;
  text-align: left; /* 强制左对齐 */
}

/* 图片容器样式 */
.chimney-left-image-container, .right-image-container {
  width: 60%;
  border-radius: 8px;
  overflow: hidden;
  margin-top: -55px;

}

.content-image {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
}

/* 右侧文字样式 - 强制左对齐 */
.chimney-right-text {
  display: flex;
  flex-direction: column;
}

.right-text-top {
  font-size: var(--font-size-lg2);;
  font-weight: 700;
  line-height: 1.2;
  text-align: left; /* 强制左对齐 */
}

.text-primary {
  color: #222;
}

.text-secondary {
  color: #d86ecc;
}

.right-text-bottom {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 15px;
}

.right-text-bottom p {
  font-size: var(--font-size-lg);
  color: #808080;
  line-height: 0.8;
  margin: 0;
  text-align: left !important; /* 强制左对齐 */
  white-space: nowrap;
  overflow: visible;
}

/* 响应式优化 - 解决重叠问题 */
@media (max-width: 992px) {
  .split-section {
    flex-direction: column;
    padding: 3rem 1.5rem;
    gap: 6rem; /* 增大间距防止重叠 */
    margin-top: 300px;
    height: auto;
    min-height: 600px;
  }

  .chimney-split-left, .split-right {
    width: 100%;
  }

  .left-text-bottom, .right-text-top {
    font-size: 26px;
  }
}

@media (max-width: 768px) {
  .split-section {
    padding: 2rem 1.5rem; /* 增加左右内边距 */
    gap: 8rem; /* 进一步增大间距 */
    margin-top: 200px;
  }

  .chimney-split-left, .split-right {
    flex-direction: column;
    gap: 3rem; /* 增大元素间间距 */
    width: 100%;
  }

  .chimney-left-text {
    margin-top: 0; /* 移除顶部margin避免与图片重叠 */
    align-items: flex-start; /* 保持左对齐 */
    padding-left: 5px; /* 增加左内边距增强左对齐视觉 */
  }

  /* 图片容器调整 */
  .chimney-left-image-container, .right-image-container {
    width: 100%; /* 图片占满宽度 */
    margin: 20px -75px; /* 增加上下margin避免重叠 */
  }

  /* 文字大小调整 */
  .left-text-top {
    font-size: 18px;
  }

  .left-text-bottom, .right-text-top {
    font-size: 22px;
  }

  .right-text-bottom {
    align-items: flex-start; /* 保持左对齐 */
    padding-left: 5px;
  }

  .right-text-bottom p {
    font-size: 14px;
    white-space: normal; /* 允许换行避免溢出 */
    text-align: left !important; /* 强制左对齐 */
  }
}

@media (max-width: 480px) {
  .split-section {
    margin-top: 150px;
    gap: 6rem;
    padding: 2rem 1rem;
  }

  .chimney-split-left, .split-right {
    gap: 2.5rem;
  }

  .left-text-bottom, .right-text-top {
    font-size: 18px;
  }

  .right-text-bottom p {
    font-size: 13px;
  }
}
</style>
